import request from '@/axios'

// 获取所有系统配置
export const getSysConfigApi = () => {
  return request.get({ url: '/api/base_web/systemConfig/details' })
}

// 保存当前配置
export const updateSysConfigApi = (data) => {
  return request.post({ url: '/api/base_web/systemConfig/save', data })
}
